const { chunk, pick, orderBy } = require('lodash');
const numeral = require('numeral');

const docToData = (doc, { withDoc = false } = {}) => {
  return { ...pick(doc, ['id', 'ref', 'exists']), ...(withDoc && { doc, }), ...doc.data() };
};

const getDocumentData = async (ref, isStrict = false) => {
  const data = docToData(await ref.get());
  return isStrict && !data.exists ? null : data;
};

const getCollectionData = async (ref, options) => {
  return (await ref.get()).docs.map(_ => docToData(_, options));
};

const getDocumentsData = async (refs) => {
  return await Promise.all(refs.map(_ => getDocumentData(_)));
};

const batch = async (db, data, f, chunkSize = 500, { firstBatch, beforeCommit = _ => _, onFailed, } = {}) => {
  const fn = async (x, data, i) => {
    const prevs = await x;

    const batch = (i === 0 && firstBatch != null) ? firstBatch : db.batch();
    const refs = await data.reduce(async (x, datum, i2) => {
      const prevs = await x;
      return [...prevs, await f(batch, datum, i * chunkSize + i2)];
    }, Promise.resolve([]));
    await beforeCommit({ index: i });
    try {
      await batch.commit();
    } catch(e) {
      const retry = (data) => fn(x, data, i);
      if(onFailed) {
        await onFailed(e, retry, data);
      } else {
        throw e;
      }
    }
    return [...prevs, ...refs];
  };

  return await chunk(data, chunkSize).reduce(fn, Promise.resolve([]));
};

const getAllCollectionDataByChunk = async (_ref, limit = 10000, lastDoc = null, prevs = []) => {
  const ref = lastDoc != null ? _ref.startAfter(lastDoc) : _ref;
  const { docs } = await ref.limit(limit).get();
  const [nextLastDoc] = docs.slice(-1);
  const all = [...prevs, ...docs.map(docToData)];
  console.log(all.length);
  return nextLastDoc == null ? all : await getAllCollectionDataByChunk(ref, limit, nextLastDoc, all);
};

module.exports = {
  docToData,
  getDocumentData,
  getCollectionData,
  getDocumentsData,
  getAllCollectionDataByChunk,
  batch,
};
